
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#25f","stroke":"#fff","stroke-width":"2","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M12.121 12.121A2.99 2.99 0 0110 13H1V4c0-.828.336-1.578.879-2.121A2.99 2.99 0 014 1h6a2.99 2.99 0 012.121.879A2.99 2.99 0 0113 4v6a2.99 2.99 0 01-.879 2.121z","stroke-opacity":".234"}}),_c('path',{attrs:{"d":"M17.121 12.121A2.99 2.99 0 0115 13H6V4c0-.828.336-1.578.879-2.121A2.99 2.99 0 019 1h6a2.99 2.99 0 012.121.879A2.99 2.99 0 0118 4v6a2.99 2.99 0 01-.879 2.121z","stroke-opacity":".5"}}),_c('path',{attrs:{"d":"M22.121 12.121A2.99 2.99 0 0120 13h-9V4c0-.828.336-1.578.879-2.121A2.99 2.99 0 0114 1h6a2.99 2.99 0 012.121.879A2.99 2.99 0 0123 4v6a2.99 2.99 0 01-.879 2.121z"}})])])
          )
        }
      }
    